import { Link } from "react-router-dom";
import { CONCERT_BG } from "@/lib/data";
import { ArrowRight } from "lucide-react";

export default function CTABand({
 kicker = "Ready?",
 headline = "Transform your music career.",
 subline = "Whether it's the Mastermind, the Monthly Membership, or our free guide. Underground Mix has a path for you.",
 cta = "Enroll Now",
 to = "/access",
}) {
 return (
 <section
 data-testid="cta-band"
 className="relative overflow-hidden grain"
 >
 <div
 className="absolute inset-0 bg-cover bg-center"
 style={{ backgroundImage: `url(${CONCERT_BG})` }}
 />
 <div className="absolute inset-0 bg-gradient-to-r from-ink-900 via-ink-900/80 to-ink-900/20" />

 <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-36">
 <div className="max-w-3xl">
 <p className="tag-kicker">{kicker}</p>
 <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.15] tracking-normal mt-5">
 {headline}
 </h2>
 <p className="mt-6 text-lg text-white/75 leading-relaxed max-w-xl">
 {subline}
 </p>
 <Link
 to={to}
 data-testid="cta-band-link"
 className="mt-10 inline-flex items-center gap-3 bg-amber hover:bg-amber-hover text-black font-bold uppercase tracking-widest text-sm px-8 py-4 rounded-sm transition-all group"
 >
 {cta}
 <ArrowRight
 size={16}
 className="transition-transform group-hover:translate-x-1"
 />
 </Link>
 </div>
 </div>
 </section>
 );
}
